// Vuelidateで使うカスタムバリデーション関数

import { helpers } from '@vuelidate/validators';

/**
 * 電話番号の桁数が正しい
 */
export const telDigitLength = (tel: number | string) => {
  if(!helpers.req(tel)) return true;

  // ハイフンなどを取り除く
  const numOnly = tel.toString().replace(/[-－ー―]/g, "");

  // 正しい桁数：携帯電話の場合は11桁、それ以外は10桁
  const validLength = /^(090|080|070|050|０９０|０８０|０７０|０５０)/.test(numOnly) ? 11 : 10;

  return numOnly.length === validLength;
}

/**
 * 電話番号のフォーマットが正しい
 */
export const telFormat = (tel: number | string) => {
  return !helpers.req(tel) || !telDigitLength(tel) || /^[0０][0-9０-９]{1,4}[-－ー―]{0,1}[0-9０-９]{2,4}[-－ー―]{0,1}[0-9０-９]{4}$/.test(tel.toString())
}

/**
 * 年収のフォーマットが正しい
 */
export const annualIncomeFormat = (num: number | string) => {
  // 半角数字のみを許容し、0で始まらないことを確認する正規表現
  const regex = /^(?!0)[0-9]+$/;
  return regex.test(num.toString());
}

export default {
  telDigitLength,
  telFormat,
  annualIncomeFormat
};
